export const mockCourses = [
  {
    id: '1',
    title: 'MBTI Personality Assessment',
    description: 'Learn about the Myers-Briggs Type Indicator and understand your personality type',
    image_url: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    duration: '2 weeks',
    level: 'Beginner',
    skills: ['Self-awareness', 'Personal Development', 'Psychology'],
    provider: 'Tezhly Academy',
    is_published: true,
    is_featured: false,
    modules: [
      {
        id: 'm1',
        title: 'Introduction to MBTI',
        duration: '2 hours',
        completed: false,
        lessons: [
          {
            id: 'l1',
            title: 'What is MBTI?',
            duration: '30 min',
            completed: false,
            type: 'video'
          },
          {
            id: 'l2',
            title: 'The 16 Personality Types',
            duration: '45 min',
            completed: false,
            type: 'reading'
          },
          {
            id: 'l3',
            title: 'MBTI Assessment',
            duration: '15 min',
            completed: false,
            type: 'quiz'
          }
        ]
      },
      {
        id: 'm2',
        title: 'Understanding Your Type',
        duration: '3 hours',
        completed: false,
        lessons: [
          {
            id: 'l4',
            title: 'Interpreting Your Results',
            duration: '45 min',
            completed: false,
            type: 'video'
          },
          {
            id: 'l5',
            title: 'Personal Development Plan',
            duration: '1 hour',
            completed: false,
            type: 'reading'
          }
        ]
      }
    ]
  },
  // ... other courses
] as const;